import axios from "axios";
import _this from "../main.js";
import user from "./user.js";
import bridgeApi from "./bridgeApi"
import errorCode from "./errcode.js";
import qs from "qs";
import { resolveBlob } from "../script/date";
//接口基础链接
const hostname = "";

const reqAndUrl = Object.assign(user, bridgeApi);

/**
 * 获取数据类
 */
class ApiService {
  getSessionData(sessionItem) {
    let sessionValue = sessionStorage.getItem(sessionItem);
    if (!sessionValue) {
      this.setSessionData(sessionItem, JSON.stringify({}));
    }
    sessionValue = sessionStorage.getItem(sessionItem);
    return JSON.parse(sessionValue);
  }

  setSessionData(sessionItem, sessionValue) {
    if (sessionValue instanceof Object) {
      return sessionStorage.setItem(sessionItem, JSON.stringify(sessionValue));
    }
    sessionStorage.setItem(sessionItem, sessionValue);
  }

  removeSessionData(sessionItem) {
    sessionStorage.removeItem(sessionItem);
  }

  getLocalData(localItem) {
    let localValue = localStorage.getItem(localItem);
    if (!localValue) {
      this.setLocalData(localItem, JSON.stringify({}));
    }
    localValue = localStorage.getItem(localItem);
    return JSON.parse(localValue);
  }

  setLocalData(localItem, localValue) {
    if (localValue instanceof Object) {
      return localStorage.setItem(localItem, JSON.stringify(localValue));
    }
    localStorage.setItem(localItem, localValue);
  }

  removeLocalData(localItem) {
    localStorage.removeItem(localItem);
  }
}

// 拦截axios请求
axios.interceptors.request.use(
  function (config) {
    // 发送请求之前做一些事情
    let authorization = ''
    if (config.url === '/api/admin/oauth/token') {
      authorization = 'Basic d2ViOjEyMzQ1Ng==';
    } else if (config.url === '/api/admin/oauth/refresh') {
      authorization = '';
    } else {
      authorization = _this.$store.state.authorization;
    }
    config.headers["Authorization"] = authorization;
    config.headers["isAdmin"] = _this.$store.state.isAdmin ? _this.$store.state.isAdmin : false;
    return config;
  },
  function (error) {
    // 挂掉之后怎么处理
    return Promise.reject(error);
  }
);
let errorCatch = (code, messages) => {
  switch (code) {
    case '110004':
      // Authorization过期,刷新token
      if (_this.$store.state.refreshTokenFlag && code === '110004') {
        _this.$store.commit("setRefreshTokenFlag", false);
        setTimeout(() => {
          _this.http.refresh({
            data: { refreshToken: _this.$store.state.refreshToken, systemType: 2 }
          }, "post").then(res => { })
        }, 0)
      }
      break;
    case '110005':
      // refresh_token过期，请重新登录
      _this.$store.commit("deleteAllMenuList");
      localStorage.clear()
      _this.$router.push({
        path: '/login'
      });
      break;
    case '100101':
      _this.$message.error('任务正在使用，不可删除');
      break;
    default:
      _this.$message.error(messages || "接口返回数据有误");
      break;
  }
};

axios.interceptors.response.use(
  function (response) {
    let arrDownloadApi = ['exportDetectionData']

    if (response.data instanceof Blob) {

      return response
    }

    if (response.config.url.indexOf('refresh') > -1) {
      if (response.data.code === '0') {
        _this.$store.commit("setRefreshTokenFlag", true);
        location.reload()
      } else {
        // refresh_token过期，请重新登录
        _this.$store.commit("setRefreshTokenFlag", true);
        _this.$store.commit("deleteAllMenuList");
        localStorage.clear()
        _this.$router.push({
          path: '/login'
        });
        return false
      }
    }
    if (response.data.code !== '0' && response.config.url.indexOf('exportBridges') === -1) {
      return Promise.reject({
        code: response.data.code,
        messages: errorCode[response.data.code] || response.data.messages,
      });
    }
    if (response.data.body && response.data.body.data && response.data.body.data.access_token) {
      _this.$store.commit("setRefreshToken", response.data.body.data.refresh_token);
      _this.$store.commit("setAuthorization", 'Bearer ' + response.data.body.data.access_token);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

for (const key in reqAndUrl) {
  let trueURL = reqAndUrl[key];
  ApiService.prototype[key] = {};
  ApiService.prototype[key] = function (data, method = "post", config = {}) {
    let queryData = data;
    if (method == "get") {
      queryData = {
        params: data,
      };
    }
    return axios[method](hostname + trueURL, queryData, config)
      .then((res) => {
        let tempObj;

        if (res.data instanceof Blob) {

          tempObj = res
        } else {
          tempObj = res.data
        }
        return tempObj;
      })

      .catch((data) => {
        errorCatch(data.code, data.messages);
        return Promise.reject(data);
      });
  };
}

export default ApiService;
